import { palette as defaultPalette } from '@classify/react-core-components/Theme';
import defaultFonts from './modules/default/constants/typographies/fonts';

export { default as OcTheme } from './components/OcTheme';

export { default as getClassesFromStyles } from './services/getClassesFromStyles';
export { default as getOcTheme } from './services/getOcTheme';
export { default as pixelToRem } from './services/pixelToRem';

const theme = {
  palette: defaultPalette,
  fonts: defaultFonts,
};

export const { palette, fonts } = theme;
